import { render, staticRenderFns } from "./RoleChangePositions.vue?vue&type=template&id=08685903&scoped=true"
import script from "./RoleChangePositions.vue?vue&type=script&lang=ts"
export * from "./RoleChangePositions.vue?vue&type=script&lang=ts"
import style0 from "./RoleChangePositions.vue?vue&type=style&index=0&id=08685903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08685903",
  null
  
)

export default component.exports